import { compose } from 'redux';
import { FC } from 'react';
import {
  withStore,
  withSaga,
  withTheming,
  configTranslation,
  withRouter,
  injectReducer,
  injectSaga,
  configGrid,
  injectTranslations,
  configAnalytics,
} from 'ia-react-core';
import { Content } from '~/interfaces/Content';
import { isLocalhost } from '~/utils/urlUtils';
import { Analytics, Constants } from 'omni-package-react-analytics';
import appTheme from '../themes/appTheme';
import App from './App';
import appReducer from './App.reducer';
import appSage from './App.saga';
import fr from './translations/fr';
import en from './translations/en';
const initialState: Partial<Content> = {
  isLoaded: false,
};
const analyticsManager = new Analytics(Constants.IDs.investiaClientSpace, {});
const storeOptions = { initialState };
export default compose<FC>(
  withStore(storeOptions),
  withSaga,
  withTheming(appTheme),
  configTranslation({
    saveCookie: isLocalhost(),
    detection: {
      order: ['cookie', 'navigator'],
      lookupCookie: 'ee_language',
    },
  }),
  withRouter({ basename: process.env.REACT_APP_ROUTER_BASENAME }),
  configGrid,
  injectReducer({
    key: 'content',
    reducer: appReducer,
    initialState: null,
    useScope: false,
    cleanState: true,
  }),
  injectSaga({
    key: 'content',
    saga: appSage,
  }),
  injectTranslations('App', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  configAnalytics({
    managers: [
      analyticsManager,
    ],
  }),
)(App);
